import React from "react";

import * as S from "./styles";

const CardRadio = ({ children, ...props }) => {
  return (
    <S.Container>
        <S.CardPlans
        selected={props.selected}
        disabled={props.disabled}
        onClick={props.disabled ? undefined : props.onClick}
        >
          {children}

          <label className="radio-wrapper" style={props.disabled ? { visibility: "hidden" } : undefined}>
              {/* Cada grupo de cards precisa do proprio name. Com um name fixo, varios
                  grupos na mesma tela viram um unico grupo no DOM e o navegador mantem
                  apenas um radio marcado, zerando a selecao dos demais. */}
              <input
              type="radio"
              id={props.id}
              name={props.name || "card_radio"}
              checked={props.checked}
              onChange={props.disabled ? undefined : props.onChange}
              />

              <span className="custom-radio" />
          </label>
        </S.CardPlans>
    </S.Container>
  );
};

export default CardRadio;
